import { createSelector } from "reselect";

export const getAllSubscriptionAddOns = (state) => state.subscriptionAddOns.addOns;

const getAllSubscriptionAddOnsNames = (state) => {
  return state.subscriptionAddOns.addOnsNames;
};

const getSubscriptionAddOnByName = (state, addOnName) => {
  return getAllSubscriptionAddOns(state) && getAllSubscriptionAddOns(state).get(`${addOnName}`);
};

export const getSubscriptionAddOnByNameSelector = createSelector(
  [getSubscriptionAddOnByName],
  (addOn) => addOn && addOn.toJS()
);

export const getAllSubscriptionAddOnsValues = createSelector(
  [getAllSubscriptionAddOns],
  (addOns) => addOns && addOns.valueSeq().toArray()
);

export const getAllSubscriptionAddOnsNamesSelector = createSelector(
  [getAllSubscriptionAddOnsNames],
  (addOnsNames) => addOnsNames && addOnsNames.toJS()
);
